import { WorkOrderTab } from '@xbcb/ui-types';
import { WorkOrderTaskType } from '../../__generated__/graphql';
import { isConnectProEnabled } from 'featureFlags';

export const DEFAULT = 'DEFAULT';
export const JP = 'JP';
export const IN = 'IN';
export const NL = 'NL';
export const GB = 'GB';
export const DE = 'DE';
export const FR = 'FR';
export const BR = 'BR';
// DEFAULT tab configuration is the full set of tabs available, i.e. the tabs you would see when looking at the full Work Order page instead of a single Work Order Task page
// N.B. A typical work order will have AT LEAST the Documents, Tasks, and Summary tabs.
export const baseEuEntryWorkOrderTabs = [
  WorkOrderTab.Documents,
  WorkOrderTab.Milestones,
  WorkOrderTab.Charges,
];
export const defaultEuEntryWorkOrderTabs = [
  ...baseEuEntryWorkOrderTabs,
  WorkOrderTab.Tasks,
  ...(isConnectProEnabled ? [WorkOrderTab.SupportCases] : []),
];

export const defaultEuEntryWorkOrderTabsForFbaScotForwardingOps = [
  WorkOrderTab.Documents,
  WorkOrderTab.Milestones,
  WorkOrderTab.Tasks,
  ...(isConnectProEnabled ? [WorkOrderTab.SupportCases] : []),
];

export const defaultFbaScotCuDeTabConfig = {
  [DEFAULT]: defaultEuEntryWorkOrderTabsForFbaScotForwardingOps,
  [WorkOrderTaskType.CUSTOMS_DECLARATION_DOCUMENT_REVIEW]: [
    WorkOrderTab.Documents,
  ],
};

export const defaultIorActivationTabs = [
  WorkOrderTab.Documents,
  WorkOrderTab.Tasks,
  WorkOrderTab.Summary,
  ...(isConnectProEnabled ? [WorkOrderTab.SupportCases] : []),
];

export const iorActivationTaskTypeTabs = [
  WorkOrderTab.Documents,
  WorkOrderTab.Summary,
];

export const baseNlCustomsDeclarationTabs = [
  WorkOrderTab.Documents,
  WorkOrderTab.Transportation,
  WorkOrderTab.Milestones,
  WorkOrderTab.Charges,
];

export const baseEuUkCuDeConfiguration = {
  [DEFAULT]: [
    ...baseNlCustomsDeclarationTabs,
    WorkOrderTab.Tasks,
    ...(isConnectProEnabled ? [WorkOrderTab.SupportCases] : []),
  ],
  // 3P task tabs
  [WorkOrderTaskType.CUSTOMS_DECLARATION_UPLOAD_DRAFT_ENTRY_DOCUMENT]:
    baseNlCustomsDeclarationTabs,
  [WorkOrderTaskType.CUSTOMS_DECLARATION_UPLOAD_DUTIES]:
    baseNlCustomsDeclarationTabs,
  [WorkOrderTaskType.CUSTOMS_DECLARATION_UPLOAD_FINAL_ENTRY_DOCUMENT]:
    baseNlCustomsDeclarationTabs,
  [WorkOrderTaskType.CUSTOMS_DECLARATION_UPLOAD_FINAL_CHARGES]:
    baseNlCustomsDeclarationTabs,
  // 1P task tabs
  [WorkOrderTaskType.CUSTOMS_DECLARATION_DOCUMENT_REVIEW]: [
    WorkOrderTab.Documents,
    WorkOrderTab.Transportation,
    WorkOrderTab.Milestones,
  ],
  [WorkOrderTaskType.CUSTOMS_DECLARATION_BUILD_TRANSPORTATION_AND_INVOICE]: [
    WorkOrderTab.Documents,
    WorkOrderTab.Transportation,
    WorkOrderTab.Milestones,
  ],
  [WorkOrderTaskType.CUSTOMS_DECLARATION_FILING]: baseNlCustomsDeclarationTabs,
  [WorkOrderTaskType.CUSTOMS_DECLARATION_DUTY_CHARGE_EXCEPTION]:
    baseNlCustomsDeclarationTabs,
};

export const getBaseEuCustomsEntryConfiguration = (customsEntryTaskType: {
  [key: string]: string;
}): {
  [x: string]: WorkOrderTab[];
} =>
  Object.values(customsEntryTaskType).reduce(
    (config: Record<string, WorkOrderTab[]>, euTaskType: string) => ({
      ...config,
      [euTaskType]: baseEuEntryWorkOrderTabs,
    }),
    {},
  );
